import { render, staticRenderFns } from "./AdmissionsStatistics.vue?vue&type=template&id=d5b44d9a&scoped=true&"
import script from "./AdmissionsStatistics.vue?vue&type=script&lang=js&"
export * from "./AdmissionsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionsStatistics.vue?vue&type=style&index=0&id=d5b44d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b44d9a",
  null
  
)

export default component.exports